import React from 'react';
import {ExclamationIcon} from '@heroicons/react/solid'

export default function ComingSoonPanel() {

  return (
    <div style={{minHeight: '35em'}} className="mx-10 bg-white overflow-hidden shadow rounded-lg divide-y divide-gray-200">
      <div className="px-4 py-5 sm:px-6">
        <h2 className="text-2xl mb-10 font-bold pb leading-7 text-gray-900 sm:text-3xl sm:truncate">
          Coming Soon
        </h2>
      </div>
      <div className="px-4  py-5 sm:p-6">
        <div className="rounded-md max-w-3xl mt-5 bg-yellow-50 p-4">
          <div className="flex">
            <div className="flex-shrink-0">
              <ExclamationIcon className="h-5 w-5 text-yellow-400" aria-hidden="true" />
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-yellow-800">Attention</h3>
              <div className="mt-2 text-sm text-yellow-700">
                <p>
                  This page is under construction and will be coming soon. Follow the team on <a href="www.twitter.com/goracle"> Twitter </a> to get updates.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


